import { c as _c } from "react/compiler-runtime";
import { useViewPort } from "@website/hooks/viewport";
import { MaterialIcon } from "@website/icons/material";
import { Modal } from "@website/ui/modal";
import { Sheet } from "@website/ui/sheet";
import { PurchaseCard } from "@website/widget/common/components/purchase-menu/components";
import { PurchaseMenuPropertiesType } from "@website/widget/common/components/purchase-menu/purchase-menu.types";
import { FC } from "react";
export const PurchaseMenu: FC<PurchaseMenuPropertiesType> = properties => {
  const $ = _c(20);
  const {
    isOpen,
    onClose,
    list
  } = properties;
  const {
    isMobile,
    isTablet
  } = useViewPort();
  if (isMobile || isTablet) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <h6 className="text-on-surface-high-emphasis text-subtitle-1">انتخاب سرویس</h6>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    let t1;
    if ($[1] !== onClose) {
      t1 = <div className="flex h-16 items-center justify-between">{t0}<button className="flex items-center justify-center"><MaterialIcon className="text-on-surface-high-emphasis text-2xl" name="close" onClick={onClose} /></button></div>;
      $[1] = onClose;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <p className="text-extra-caption text-on-surface-high-emphasis h-4">برای پیگیری سفارش، سرویس مورد نظر را انتخاب کنید.</p>;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t1) {
      t3 = <div className="flex flex-col gap-2">{t1}{t2}</div>;
      $[4] = t1;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== list) {
      t4 = <PurchaseCard list={list} />;
      $[6] = list;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[8] !== isOpen || $[9] !== onClose || $[10] !== t3 || $[11] !== t4) {
      t5 = <Modal className="!py-0" mobileHeight="auto" onClose={onClose} open={isOpen}>{t3}{t4}</Modal>;
      $[8] = isOpen;
      $[9] = onClose;
      $[10] = t3;
      $[11] = t4;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    return t5;
  }
  let t0;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col gap-2 px-4 py-2"><h6 className="text-subtitle-1 text-on-surface-high-emphasis h-6">انتخاب سرویس</h6><p className="text-extra-caption text-on-surface-high-emphasis h-4">برای پیگیری سفارش، سرویس مورد نظر را انتخاب کنید.</p></div>;
    $[13] = t0;
  } else {
    t0 = $[13];
  }
  let t1;
  if ($[14] !== list) {
    t1 = <PurchaseCard list={list} />;
    $[14] = list;
    $[15] = t1;
  } else {
    t1 = $[15];
  }
  let t2;
  if ($[16] !== isOpen || $[17] !== onClose || $[18] !== t1) {
    t2 = <Sheet onClose={onClose} open={isOpen} xGap="16px" xPosition="end" yPosition="end">{t0}{t1}</Sheet>;
    $[16] = isOpen;
    $[17] = onClose;
    $[18] = t1;
    $[19] = t2;
  } else {
    t2 = $[19];
  }
  return t2;
};